// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let NewOrderMessage = function (fieldSet)
{
    this.Code = Message.CODE_NEW_ORDER_MESSAGE
    PFixMessage.call(this, fieldSet)
}

NewOrderMessage.prototype = Object.create(PFixMessage.prototype)

NewOrderMessage.prototype.setOnBehalfId = function (onBehalfId)
{
    this.setFieldValue(FieldsFactory.FIELD_ON_BEHALF_USER_ID, onBehalfId)
}

NewOrderMessage.prototype.setPlacedFrom = function (placedFrom)
{
    this.setFieldValue(FieldsFactory.FIELD_CLIENT_PANEL_ID, placedFrom)
}